import { createFileRoute } from "@tanstack/react-router";
import { SecuritySection } from "@/components/security/security-section";

export const Route = createFileRoute("/security")({
	component: SecuritySection,
});
